<template>
  <div style="padding-top: 10px;" :style="{height:mHeight}">
    <el-col :span="1"><div class="grid-content"></div></el-col>
    <el-col :span="22" style="background-color: #ffffff">
      <div style="height: 40px;margin-bottom: -30px;">
        <el-image fit="scale-down" style="width: 33%;height: 100%;display: inline-block"  src="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-121.png"></el-image>
        <el-image fit="scale-down"  style="width: 33%;height: 100%;display: inline-block"  src="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-122.png"></el-image>
        <el-image fit="scale-down"  style="width: 33%;height: 100%;display: inline-block"  src="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-123.png"></el-image>
      </div>
      <el-tabs class="selfdiv" :stretch="true" v-model="activeName" @tab-click="handleClick" style="margin-top: 0px;" :style="{fontSize:minFontSize}">
        <el-tab-pane label="领先科技" name="first">
        </el-tab-pane>
        <el-tab-pane label="科研平台" name="second">
        </el-tab-pane>
        <el-tab-pane label="专利证书" name="third">
        </el-tab-pane>
      </el-tabs>
      <div v-show="showIndex==0">
        <el-col :span="1"><div class="grid-content"></div></el-col>
        <el-col :span="22">
          <div style="margin-top: 20px;">
            <div :style="{height:titleH}">
              <el-image src="http://zgpic.xingfujijiu.cn/333.png"></el-image>
              <el-image style="width: 80%;margin-top: 25px;float: left;" src="http://zgpic.xingfujijiu.cn/222.png"></el-image>
            </div>
            <div style="width: 100%;" :style="{height:contentH}">
              <el-image style="width: 100%;margin-top: 10px" fit="scale-down" src="http://zgpic.xingfujijiu.cn/%E4%B8%AD%E8%B0%B7%E9%9B%86%E5%9B%A2%20%E5%AE%98%E7%BD%91%E6%89%8B%E6%9C%BA%E7%89%88%20%E5%9B%BE%E6%A0%87_%20-81.png"></el-image>
              <el-image style="width: 100%;margin-top: 10px" fit="scale-down" src="http://zgpic.xingfujijiu.cn/%E4%B8%AD%E8%B0%B7%E9%9B%86%E5%9B%A2%20%E5%AE%98%E7%BD%91%E6%89%8B%E6%9C%BA%E7%89%88%20%E5%9B%BE%E6%A0%87_%20-82.png"></el-image>
              <el-image style="width: 100%;margin-top: 10px" fit="scale-down" src="http://zgpic.xingfujijiu.cn/%E4%B8%AD%E8%B0%B7%E9%9B%86%E5%9B%A2%20%E5%AE%98%E7%BD%91%E6%89%8B%E6%9C%BA%E7%89%88%20%E5%9B%BE%E6%A0%87_%20-83.png"></el-image>
            </div>
          </div>
        </el-col>
        <el-col :span="1"><div class="grid-content"></div></el-col>
      </div>
      <div v-show="showIndex==1">
        <el-col :span="1"><div class="grid-content"></div></el-col>
        <el-col :span="22">
          <div style="margin-top: 20px;">

            <div :style="{height:titleH}">
              <el-image src="http://zgpic.xingfujijiu.cn/a111.png"></el-image>
              <el-image style="width: 80%;margin-top: 25px;float: left;" src="http://zgpic.xingfujijiu.cn/a222.png"></el-image>
            </div>

            <div style="width: 100%;margin-top: 30px" :style="{height:contentH1}">
              <div style="width: 100%;height: 33%;margin-top: 10px;">
                <el-image src="http://zgpic.xingfujijiu.cn/%E4%B8%AD%E8%B0%B7%E9%9B%86%E5%9B%A2%20%E5%AE%98%E7%BD%91%E6%89%8B%E6%9C%BA%E7%89%88%20%E5%9B%BE%E6%A0%87_%20-78.png"></el-image>
                <el-image src="http://zgpic.xingfujijiu.cn/dp1.png"></el-image>
              </div>
              <div style="width: 100%;height: 33%;margin-top: 10px;">
                <el-image src="http://zgpic.xingfujijiu.cn/%E4%B8%AD%E8%B0%B7%E9%9B%86%E5%9B%A2%20%E5%AE%98%E7%BD%91%E6%89%8B%E6%9C%BA%E7%89%88%20%E5%9B%BE%E6%A0%87_%20-79.png"></el-image>
                <el-image src="http://zgpic.xingfujijiu.cn/dp2.png"></el-image>
              </div>
              <div style="width: 100%;height: 33%;margin-top: 10px;">
                <el-image src="http://zgpic.xingfujijiu.cn/%E4%B8%AD%E8%B0%B7%E9%9B%86%E5%9B%A2%20%E5%AE%98%E7%BD%91%E6%89%8B%E6%9C%BA%E7%89%88%20%E5%9B%BE%E6%A0%87_%20-80.png"></el-image>
                <el-image src="http://zgpic.xingfujijiu.cn/dp3.png"></el-image>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="1"><div class="grid-content"></div></el-col>
      </div>
      <div v-show="showIndex==2" style="width: 100%;" :style="{height:zsH}">
        <div style="width: 100%;background-color: #eeeef0" :style="{marginLeft:leftW,width:bodyW}">
          <el-image  style="width: 80%;margin: 30px auto 0px;" src="http://zgpic.xingfujijiu.cn/111.png"></el-image>
          <el-image  style="width: 80%;margin: 30px auto 30px;" src="http://zgpic.xingfujijiu.cn/222.png"></el-image>
        </div>
      </div>
    </el-col>
    <el-col :span="1">
      <div class="grid-content"></div>
    </el-col>
  </div>
</template>
<script>
import PubSub from "pubsub-js";

export default {
  name: "tech",
  methods:{
    handleClick(tab) {
      this.changeIndex=tab._data.index;
      switch (tab._data.index){
        case '0':
          PubSub.publish('changeIndex', {"name":"tech","query":{"step":"first"}});
          this.$router.push({query:{'step':'first'}});
          this.showIndex=0;
          this.mHeight=document.body.clientWidth*20/24*1450/350+'px';
          break;
        case '1':
          PubSub.publish('changeIndex', {"name":"tech","query":{"step":"second"}});
          this.$router.push({query:{'step':'second'}});
          this.showIndex=1;
          this.mHeight=document.body.clientWidth*20/24*1200/350+'px';
          break;
        case '2':
          PubSub.publish('changeIndex', {"name":"tech","query":{"step":"third"}});
          this.$router.push({query:{'step':'third'}});
          this.showIndex=2;
          this.mHeight=document.body.clientWidth*20/24*1400/350+'px';
          break;
      }
    }
  },
  data(){
    return {
      currentPage:0,
      maxItems:9,
      techItems:[{name:"wenxin",age:21},{name:"xiaowen",age: 20}],
      techItem:1,
      activeName: 'first',
      mHeight:'',
      changeIndex:'0',
      minFontSize:document.body.clientWidth/25+"px",
      height1:'',
      elH:(document.body.clientWidth*20/24*1200/1509+100)*0.5*0.6+'px',
      titleH:document.body.clientWidth*20/24*260/350+'px',
      contentH:document.body.clientWidth*20/24*20/24*0.41153+"px",
      contentH1:document.body.clientWidth*20/24*750/350+"px",
      contentH2:document.body.clientWidth*900/1920+"px",
      showIndex:0,
      leftW:'-'+document.body.clientWidth/24+'px',
      bodyW:document.body.clientWidth+'px',
      bodyH:document.body.clientWidth*620/1920+'px',
      zsH:document.body.clientWidth*900/1920+'px',
      iconH:document.body.clientWidth*0.10416*0.35+"px"
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function() {
        this.activeName=this.$route.query.step;
        switch (this.$route.query.step){
          case 'first':
            this.currentPage=0;
            this.changeIndex=0;
            this.showIndex=0;
            this.mHeight=document.body.clientWidth*20/24*1450/350+'px';
            break;
          case 'second':
            this.currentPage=1;
            this.changeIndex=1;
            this.showIndex=1;
            this.mHeight=document.body.clientWidth*20/24*1200/350+'px';
            break;
          case 'third':
            this.currentPage=2;
            this.changeIndex=2;
            this.showIndex=2;
            this.mHeight=document.body.clientWidth*20/24*1400/350+'px';
            break;
        }
      }
    }
  },
  created() {
    PubSub.publish('changeIndex', this.$route);
    //请求数据接口
    this.techItem=this.techItems.length;
  },
  mounted() {

    setTimeout(function(){
      //手动触发窗口resize事件
      if(document.createEvent) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("resize", true, true);
        window.dispatchEvent(event);
      } else if(document.createEventObject) {
        window.fireEvent("onresize");
      }
    },1);

    window.addEventListener("resize", () => {
      this.minFontSize=document.body.clientWidth/25+"px";
      var lists=this.$el.querySelectorAll('.el-tabs__nav .el-tabs__item');
      for (var i=0;i<lists.length;i++) {
        lists[i].style.fontSize=document.body.clientWidth/30+"px";
      }
      this.height1=document.body.clientWidth*20/24*1200/1509+'px';
      this.titleH=document.body.clientWidth*20/24*260/350+'px';
      this.contentH=document.body.clientWidth*20/24*20/24*0.41153+"px";
      this.contentH1=document.body.clientWidth*20/24*750/350+"px";
      this.contentH2=document.body.clientWidth*900/1920+"px";
      this.elH=(document.body.clientWidth*20/24*1200/1509+100)*0.5*0.6+'px';


      this.leftW='-'+document.body.clientWidth/24+'px';
      this.bodyW=document.body.clientWidth+'px';
      this.bodyH=document.body.clientWidth*620/1920+'px';
      this.iconH=document.body.clientWidth*0.10416*0.35+"px";

      this.zsH=document.body.clientWidth*900/1920+'px';

      switch (this.changeIndex){
        case 0:
          this.mHeight=document.body.clientWidth*20/24*1450/350+'px';
          break;
        case 1:
          this.mHeight=document.body.clientWidth*20/24*1200/350+'px';
          break;
        case 2:
          this.mHeight=document.body.clientWidth*20/24*1400/350+'px';
          break;
      }

    });
  },

}
</script>

<style lang="scss">

.selfdiv{
  .el-tabs__active-bar.is-top{
    background:url("http://zgpic.xingfujijiu.cn/bline.png") no-repeat 100%;
    background-position: center;
    height: 13px;
  }
  .el-tabs__nav-wrap::after{
    background-color: #cfcfcf;
    height: 1px;
  }
  .el-tabs__item.is-active{
    color: #ff5e0e;
  }
  .el-tabs__item.is-top:hover{
    color: #ff5e0e;
  }
  .el-tabs__item.is-top{
    height: 50px;
  }
  .el-tabs.el-tabs--top{
    margin-top: 50px;
  }
  .el-tabs__item{
    padding: 0px;
  }
}

.pointer:hover{
  cursor: pointer;
}
</style>